import * as server from '../entries/pages/o-kancelarii/_page.server.ts.js';

export const index = 9;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/o-kancelarii/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/o-kancelarii/+page.server.ts";
export const imports = ["_app/immutable/nodes/9.C6JYfvZv.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/Cl8rW3gV.js","_app/immutable/chunks/CpR9_xLq.js"];
export const stylesheets = [];
export const fonts = [];
